import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	createProject: {
		data: undefined,
		isLoading: false,
		hasBeenLoaded: false,
		error: ''
	}
};

export const projectSlice = createSlice({
	name: 'project',
	initialState,
	reducers: {
		createProject: (state) => {
			state.createProject.isLoading = true;
			state.createProject.hasBeenLoaded = false;
		},
		createProjectCompleted: (state, action) => {
			state.createProject.isLoading = false;
			state.createProject.data = action.payload;
			state.createProject.hasBeenLoaded = true;
			state.createProject.error = '';
		},
		createProjectFailed: (state, action) => {
			state.createProject.isLoading = false;
			state.createProject.hasBeenLoaded = false;
			state.createProject.error = action.payload;
		}
	}
});

export const { createProject, createProjectCompleted, createProjectFailed } =
	projectSlice.actions;

export default projectSlice.reducer;
